import dayjs from "dayjs"
import dayjsDurationPlugin from "dayjs/plugin/duration"

dayjs.extend(dayjsDurationPlugin)

export const formatDuration = (duration: number): string => {
  const dur = dayjs.duration(duration, "s")
  const hours = Math.floor(dur.asHours())
  const minutes = dur.minutes()
  const seconds = dur.seconds()

  const parts = []
  if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`)
  if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`)
  if (seconds > 0) parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`)

  return parts.join(" ") || "0 seconds"
}
